import React,{useEffect,useId,useRef,useState} from 'react';
import {Camera,LoaderCircle,UserRound} from 'lucide-react';
import {useCareerLanguage} from './CareerLanguage';
import './CareerProfilePhotoCard.css';

export default function CareerProfilePhotoCard({photo,busy,onChange}){
 const {t}=useCareerLanguage(),input=useRef(null),id=useId(),[imageFailed,setImageFailed]=useState(false);
 useEffect(()=>setImageFailed(false),[photo]);
 return <div className="profil-ayar-card profil-photo-card" aria-busy={busy}>
  <div className="profil-ayar-photo">{photo&&!imageFailed?<img src={photo} alt={t('photo')} onError={()=>setImageFailed(true)}/>:<UserRound size={27} aria-hidden="true"/>}</div>
  <div className="profil-ayar-info"><strong>{t('photo')}</strong><small>{t('profilePhotoHint')}</small></div>
  <button type="button" className="profil-ayar-change-btn" aria-controls={id} onClick={()=>input.current?.click()} disabled={busy}>{busy?<LoaderCircle size={16} className="profil-photo-spin" aria-hidden="true"/>:<Camera size={16} aria-hidden="true"/>}{t(busy?'loading':photo?'profilePhotoChange':'profilePhotoAdd')}</button>
  <input ref={input} id={id} type="file" accept="image/*" onChange={onChange} disabled={busy} hidden/>
 </div>;
}
